import React, { FC, useMemo } from 'react';

import type { EmailDocument } from '../model/types';
import { renderEmailHtml } from '../render/renderEmailHtml';

export type PreviewDevice = 'desktop' | 'mobile';

interface EmailPreviewProps {
  doc: EmailDocument;
  device: PreviewDevice;
}

/**
 * Podgląd w ramce `iframe`, a nie wprost w drzewie panelu.
 *
 * Wiadomość niesie własne style dla `body` i tabel, a wstawiona bez izolacji zderzyłaby
 * się z arkuszem panelu: Tailwind zeruje marginesy, panel narzuca własną rodzinę pisma i
 * podgląd przestałby odpowiadać temu, co zobaczy odbiorca. `srcDoc` renderuje dokładnie
 * ten sam kod, który pójdzie w wysyłce.
 */
export const EmailPreview: FC<EmailPreviewProps> = ({ doc, device }) => {
  const html = useMemo(() => renderEmailHtml(doc), [doc]);
  const width = device === 'mobile' ? 390 : Math.max(doc.theme.width + 80, 680);

  return (
    <div className="flex h-full w-full justify-center overflow-auto bg-gray-100 p-6">
      <iframe
        title="Podgląd wiadomości"
        srcDoc={html}
        sandbox=""
        className="h-full rounded-xl border border-gray-200 bg-white shadow-sm"
        style={{ width, minHeight: 640 }}
      />
    </div>
  );
};
